import { Clonable } from '../../../common';

export class Industry extends Clonable {
  constructor(
    public readonly id: string,
    public readonly album: Record<string, string>,
    public readonly name: Record<string, string>,
  ) {
    super();
  }
}
